/**
 * KOZ Review Grid — horizontal carousel paging by viewport width.
 */
(function () {
  function init(root) {
    var viewport = root.querySelector('[data-koz-review-viewport]');
    var prevBtns = root.querySelectorAll('[data-koz-review-prev]');
    var nextBtns = root.querySelectorAll('[data-koz-review-next]');
    if (!viewport) return;

    function updateButtons() {
      var maxScroll = viewport.scrollWidth - viewport.clientWidth;
      var atStart = viewport.scrollLeft <= 1;
      var atEnd = viewport.scrollLeft >= maxScroll - 1;
      var needsNav = maxScroll > 1;

      prevBtns.forEach(function (btn) {
        btn.hidden = !needsNav;
        btn.disabled = atStart;
      });
      nextBtns.forEach(function (btn) {
        btn.hidden = !needsNav;
        btn.disabled = atEnd;
      });
    }

    function scrollByPage(direction) {
      viewport.scrollBy({
        left: direction * viewport.clientWidth,
        behavior: 'smooth'
      });
    }

    prevBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        scrollByPage(-1);
      });
    });

    nextBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        scrollByPage(1);
      });
    });

    viewport.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons);
    updateButtons();
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-koz-review-carousel]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    boot(e.target);
  });
})();
